import { useLocation, Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/storage';
import { useUserSubscriptionContext } from '../contexts/userSubscriptionContext';
import LoadingPage from '../components/LoadingPage';

const ALLOWED_WHILE_BLOCKED = ['/User/payments', '/logout'];

function PrivateRoute({ children }) {
  const location = useLocation();
  const { subscription, isLoading } = useUserSubscriptionContext();

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // Aguarda carregamento inicial antes de decidir bloqueio (evita flash de acesso indevido)
  if (isLoading) {
    return <LoadingPage />;
  }

  const isBlocked = subscription?.name === 'blocked';
  // Comparação case-insensitive: a rota é /User/:tab mas alguns navigates usam /user/... (minúsculo).
  // Sem isso, um usuário bloqueado em /user/payments seria redirecionado e o componente remontaria.
  const pathname = location.pathname.toLowerCase();
  const isAllowed = ALLOWED_WHILE_BLOCKED.some(path => pathname.startsWith(path.toLowerCase()));

  if (isBlocked && !isAllowed) {
    return <Navigate to="/User/payments" state={{ openPlans: true, blockedFromDashboard: true }} replace />;
  }

  return children;
}

export default PrivateRoute;
